export default __webpack_public_path__ + "static/media/encrypted-ph.4d295b88.webp";